class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");

    if (!this.form) return;

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector("cart-notification");
    this.errorMessage = document.querySelector(".error-messaging");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    this.cartNotification.setActiveElement(document.activeElement);

    const productAddedEvent = new Event("product:added");
    const quantityContainer = this.form.closest(".product__form").parentNode;
    const submitButton = this.querySelector('[type="submit"]');
    const buttonText = submitButton.querySelector("span");
    const icon = document.querySelector(".header__icon--cart");
    let quantity = document.querySelector(".quantity__input").value;

    if (quantityContainer.querySelector(".quantity__input")) {
      quantity =
        quantityContainer.querySelector(".quantity__input").value || quantity;
    }

    // Find current swatch to get the SKU
    let currentSwatch = document.querySelector(".swatch input:checked");
    if (!currentSwatch) {
      const id = document.querySelector(
        '[data-type="add-to-cart-form"] input[name="id"]'
      ).value;
      currentSwatch = document.querySelector(
        `.product-select option[value="${id}"]`
      );
    }

    const canUpdateQuantity = async (skusToValidate) => {
      let _canUpdateQuantity = true;
      if (window.QuantityLimit) {
        try {
          _canUpdateQuantity = await window.QuantityLimit.validateQuantityLimit(
            skusToValidate
          );
        } catch (e) {
          console.log(e);
        }
      }
      return _canUpdateQuantity;
    };

    const formData = JSON.parse(serializeForm(this.form));

    // Include inputs/selects/textareas that are associated via form="..." (outside the form element).
    // FormData(form) may omit these in some browsers, so we merge them in explicitly.
    const formId = this.form.id;
    if (formId) {
      const formAssociated = document.querySelectorAll(
        `input[form="${formId}"], select[form="${formId}"], textarea[form="${formId}"]`
      );
      formAssociated.forEach((el) => {
        if (!el.name) return;
        // Skip inputs inside hidden ancestors (e.g. inactive nested custom-option branches)
        if (el.closest('[hidden]')) return;
        if (el.type === "checkbox" || el.type === "radio") {
          if (el.checked) formData[el.name] = el.value;
          return;
        }
        if (!el.disabled) formData[el.name] = el.value;
      });
    }

    // Add embroidered property to form data. Pending to create a more performant solution to support custom properties.
    let properties = {};
    const embroideredName = document.querySelector(".embroidered__input");
    const embroideredColor = document.querySelector(".embroidered__color");
    const preorder =
      this.form.querySelector(
        'input[name="properties[Pre-order]"], input[name="properties[Backorder]"]'
      ) ||
      document.querySelector(
        'input[name="properties[Pre-order]"], input[name="properties[Backorder]"]'
      );
    const finalSale = document.querySelector(
      'input[name="properties[__FinalSale]"]'
    );
    const productMessaging = document.querySelector('input[name="properties[__ProductMessaging]"]');

    // Add every __C-prefixed field as a line item property (omit empty values; skip Fee ID).
    for (const key in formData) {
      if (key.startsWith("__C ")) {
        if (key.endsWith(" Fee ID")) continue;
        const val = formData[key];
        if (val === undefined || val === "") continue;
        properties[key] = val;
        if (key !== "__C Photo") {
          properties[key.replace("__C ", "")] = val;
        }
      }
      // Keys like "properties[__C Option Input]" or "properties[__C Option Fee ID]"
      if (key.startsWith("properties[") && key.endsWith("]")) {
        const propName = key.slice(11, -1);
        if (!propName.startsWith("__C ") || propName.endsWith(" Fee ID")) continue;
        const val = formData[key];
        if (val === undefined || val === "") continue;
        properties[propName] = val;
        if (propName !== "__C Photo") {
          properties[propName.replace("__C ", "")] = val;
        }
      }
    }

    const embroideredVariantJson = JSON.parse(document.querySelector("[data-embroidered]")?.innerText || "{}");
    const embroideredFeeVariantId = document.querySelector('[data-embroidered-fee-variant-id]')?.value;
    const embroideredVariantId = embroideredFeeVariantId || embroideredVariantJson.embroidered_variant_id;
    
    const excludedProducts = embroideredVariantJson?.embroidered_product_exclusions || [];
    const embroideredPropertyName = document.querySelector('input[name="properties[__EmbroideredPropertyName]"]')?.value;
    const embroideredFeeLabel = document.querySelector('input[name="properties[__EmbroideredFeeLabel]"]')?.value;
    if (embroideredPropertyName) {
      properties["__EmbroideredPropertyName"] = embroideredPropertyName;
    }
    if (embroideredFeeLabel) {
      properties["__EmbroideredFeeLabel"] = embroideredFeeLabel;
    }
    if (embroideredName && embroideredName.value !== "") {
      properties["_embroidered_name"] = embroideredName.value;
      properties["Embroidered Name"] = embroideredName.value;
      properties["_LPROP"] = "Final Sale";
      if (embroideredColor && embroideredColor.value !== "") {
        properties["_embroidered_color"] = embroideredColor.value;
        properties["Embroidered Color"] = embroideredColor.value;
      }
    }
    if (embroideredVariantId && embroideredName && embroideredName.value !== "") {
      properties[embroideredName.dataset.propertyName] = embroideredName.value;
      properties["_embroidered_name"] = embroideredName.value;
      properties["_embroidered_id"] = `emb-${Math.floor(Math.random() * 10000) + 1}`
      properties["_embroidered_main"] = "true";
      properties["_LPROP"] = "Final Sale";
    }
    if (preorder) {
      const preorderKey = preorder.name.slice("properties[".length, -1);
      properties[preorderKey] = preorder.value;
    }
    if (finalSale) {
      properties["__FinalSale"] = finalSale.value;
    }
    if (productMessaging) {
      properties["__ProductMessaging"] = productMessaging.value;
    }
    // Add gift card properties
    const gcContainer = document.querySelector("[data-gift-card-container]");
    if (gcContainer) {
      const inputErrorMesasge = gcContainer.querySelector(
        ".inputs-required-error"
      );
      const gcRecipient = gcContainer.querySelector("#gc_recipient").value;
      const gcMessage = gcContainer.querySelector("#gc_message").value;

      inputErrorMesasge.classList.remove("show");

      // validate empty fields
      if (!gcRecipient || !gcMessage) {
        inputErrorMesasge.classList.add("show");
        return false;
      }

      // validate gift card fields before adding to cart return false if not valid
      if (
        gcContainer.querySelector("#gc_recipient").classList.contains("error")
      ) {
        gcContainer.querySelector("#gc_recipient").classList.add("red-border");
        gcContainer.querySelector("#gc_recipient").focus();
        return false;
      }

      if (gcRecipient !== "" && gcMessage !== "") {
        properties["GC Recipient"] = gcRecipient;
        properties["GC Message"] = gcMessage;
        properties["_gc_timestamp"] = Date.now() + Math.random();
      }
    }

    canUpdateQuantity({
      [currentSwatch.dataset.sku]: quantity,
    }).then((canUpdate) => {
      if(!canUpdate) return;

      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("loading");
      buttonText.dataset.text = buttonText.innerText;
      buttonText.innerText = "Adding";
      if (this.errorMessage) {
        this.errorMessage.style.display = "none";
      }

      const mainVariantId = +formData.id;
      const feeInputs = Array.from(document.querySelectorAll('input[data-fee-input-for-option]')).filter(
        (input) => input.form === this.form
      );
      const feeVariantIds = feeInputs
        .map((input) => (input.value && input.value.trim()) ? parseInt(input.value.trim(), 10) : 0)
        .filter((id) => id > 0);
      if (feeVariantIds.length > 0) {
        properties["_fee_variant_ids"] = feeVariantIds.join(",");
      }
      const mainItem = {
        id: mainVariantId,
        quantity: parseInt(quantity, 10) || 1,
        properties,
      };
      const feeItems = feeVariantIds.map((feeId) => ({
        id: feeId,
        quantity: 1,
        properties: {
          _is_fee_for_customization: "true",
          _fee_parent_product_id: String(mainVariantId),
        }
      }));
      
      const items = [mainItem, ...feeItems];
      const body = JSON.stringify({
        items,
        sections: this.cartNotification
          .getSectionsToRender()
          .map((section) => section.id),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}.js`, {
        ...fetchConfig(),
        body,
      })
        .then(async (response) => {
          if (!response.ok) {
            if (response.status === 422) {
              const res = await response.json();
              throw new Error(res.message);
            }
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("disabled");
          buttonText.innerText = "Added";
          const screenReaderMessage = document.createElement("div"); // Create a new div element to announce "cart has been updated" to screen readers
          screenReaderMessage.textContent = "Cart has been updated.";
          screenReaderMessage.setAttribute("aria-live", "polite");
          screenReaderMessage.classList.add("screen-reader-message");
          document.body.appendChild(screenReaderMessage);
          document.dispatchEvent(productAddedEvent);

      
          const isExcluded = excludedProducts.find((product) => product.variants.find((variant) => variant.id == formData.id));
          
          if (!isExcluded && embroideredVariantId && properties["_embroidered_name"] && properties["_embroidered_name"] !== "") {
            fetch(`${routes.cart_add_url}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                quantity: 1,
                id: embroideredVariantId,
                properties: Object.assign({
                  _embroidered_name: properties["_embroidered_name"],
                  _embroidered_id: properties["_embroidered_id"],
                  _LPROP: "Final Sale"
                }, !!properties?._embroidered_color ? {
                  _embroidered_color: properties._embroidered_color,
                  'Embroidered Color': properties._embroidered_color
                } : {})
              }),
            }).then((response) => response.json());
          }

          if (icon) {
            icon.classList.add("active");
            //update number in header
            fetch("/cart.js")
              .then((response) => response.json())
              .then((data) => {
                icon
                  .querySelectorAll(".cart-count-bubble span")
                  .forEach((el) => {
                    el.innerText = data.item_count;
                  });
              });
          }
          setTimeout(() => {
            buttonText.innerText = buttonText.dataset.text;
            if (icon) {
              icon.classList.remove("active");
            }
            // open minicart
            this.miniCart = document.querySelector("[data-mini-cart-panel]");
            this.openMiniCart = new CustomEvent("openMiniCart");
            this.minicartPanel = new window.Panel({
              el: document.querySelector("[data-mini-cart-panel]"),
            });
            this.miniCart.dispatchEvent(this.openMiniCart);
            this.minicartPanel.open();
          }, 1000);
        }).catch((e) => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("disabled");
          buttonText.innerText = buttonText.dataset.text;
          if (this.errorMessage) {
            this.errorMessage.style.display = "block";
            this.errorMessage.innerText = e.message;
          }
        });
    });
  }
}
customElements.define("product-form", ProductForm);
